import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ed40ce2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "informationConfirmModal",
  tabindex: "-1",
  "aria-labelledby": "informationConfirmModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body content" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "row col-12 mx-0 px-0" }
const _hoisted_12 = { class: "fs-7 mb-2 text-center red-text" }
const _hoisted_13 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_14 = {
  key: 0,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_15 = { class: "row mx-0 px-0 pr-10" }
const _hoisted_16 = { class: "w-max-content col-lg-3" }
const _hoisted_17 = { class: "col-lg-4 text-max-content" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_19 = { class: "col-lg-4 text-max-content value-compare" }
const _hoisted_20 = {
  key: 1,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_21 = { class: "row mx-0 px-0 pr-10" }
const _hoisted_22 = { class: "w-max-content col-lg-3" }
const _hoisted_23 = { class: "col-lg-4 text-max-content" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_25 = { class: "col-lg-4 text-max-content value-compare" }
const _hoisted_26 = {
  key: 2,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_27 = { class: "row mx-0 px-0 pr-10" }
const _hoisted_28 = { class: "w-max-content col-lg-3" }
const _hoisted_29 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" ～ ")
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 1,
  class: "col-lg-4"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_35 = {
  key: 0,
  class: "col-lg-4 value-compare"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" ～ ")
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 3,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_40 = { class: "row mx-0 px-0 pr-10" }
const _hoisted_41 = { class: "w-max-content col-lg-3" }
const _hoisted_42 = { class: "col-lg-4 text-max-content" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_44 = { class: "col-lg-4 text-max-content value-compare" }
const _hoisted_45 = {
  key: 4,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_46 = { class: "row mx-0 px-0 pr-10" }
const _hoisted_47 = { class: "w-max-content col-lg-3" }
const _hoisted_48 = { class: "col-lg-4 text-break" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_50 = { class: "col-lg-4 text-break value-compare" }
const _hoisted_51 = {
  key: 5,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_52 = { class: "row px-0 mx-0 pr-10" }
const _hoisted_53 = { class: "w-max-content col-lg-3" }
const _hoisted_54 = { class: "col-lg-4 text-max-content" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_56 = { class: "col-lg-4 text-max-content value-compare" }
const _hoisted_57 = { class: "col-12" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "row col-12 px-0 mx-0" }
const _hoisted_60 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_61 = {
  key: 0,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_62 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_63 = { class: "w-max-content col-lg-3" }
const _hoisted_64 = { class: "col-lg-4 text-max-content" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_66 = { class: "col-lg-4 text-max-content value-compare" }
const _hoisted_67 = {
  key: 1,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_68 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_69 = { class: "w-max-content col-lg-3" }
const _hoisted_70 = { class: "col-lg-4 text-max-content" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_72 = { class: "col-lg-4 text-max-content value-compare" }
const _hoisted_73 = {
  key: 2,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_74 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_75 = { class: "w-max-content col-lg-3" }
const _hoisted_76 = { class: "col-lg-4 text-max-content" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_78 = { class: "col-lg-4 text-max-content value-compare" }
const _hoisted_79 = {
  key: 3,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_80 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_81 = { class: "w-max-content col-lg-3" }
const _hoisted_82 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_83 = { key: 0 }
const _hoisted_84 = /*#__PURE__*/_createTextVNode("～")
const _hoisted_85 = { key: 1 }
const _hoisted_86 = {
  key: 1,
  class: "col-lg-4"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_88 = {
  key: 0,
  class: "col-lg-4 value-compare"
}
const _hoisted_89 = { key: 0 }
const _hoisted_90 = /*#__PURE__*/_createTextVNode("～")
const _hoisted_91 = { key: 1 }
const _hoisted_92 = {
  key: 4,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_93 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_94 = { class: "w-max-content col-lg-3" }
const _hoisted_95 = { class: "col-lg-4 text-max-content" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_97 = { class: "col-lg-4 text-max-content value-compare" }
const _hoisted_98 = {
  key: 5,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_99 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_100 = { class: "w-max-content col-lg-3" }
const _hoisted_101 = { class: "col-lg-4 text-break" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_103 = { class: "col-lg-4 text-break value-compare" }
const _hoisted_104 = {
  key: 6,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_105 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_106 = { class: "w-max-content col-lg-3" }
const _hoisted_107 = { class: "col-lg-4 text-max-content" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_109 = { class: "col-lg-4 text-max-content value-compare" }
const _hoisted_110 = {
  key: 0,
  class: "col-12"
}
const _hoisted_111 = { class: "row col-12 px-0 mx-0" }
const _hoisted_112 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_113 = {
  key: 0,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_114 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_115 = { class: "w-max-content col-lg-3 text-max-content" }
const _hoisted_116 = {
  key: 0,
  class: "col-lg-4 text-break"
}
const _hoisted_117 = {
  key: 1,
  class: "col-lg-4 text-break pre-line"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_119 = { class: "col-lg-4 text-break pre-line value-compare" }
const _hoisted_120 = {
  key: 1,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_121 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_122 = { class: "w-max-content col-lg-3 text-max-content" }
const _hoisted_123 = {
  key: 0,
  class: "col-lg-4 text-break"
}
const _hoisted_124 = {
  key: 1,
  class: "col-lg-4 text-break pre-line"
}
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_126 = { class: "col-lg-4 text-break pre-line value-compare" }
const _hoisted_127 = {
  key: 2,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_128 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_129 = { class: "w-max-content col-lg-3 text-max-content" }
const _hoisted_130 = {
  key: 0,
  class: "col-lg-4 text-break"
}
const _hoisted_131 = {
  key: 1,
  class: "col-lg-4 text-break pre-line"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_133 = { class: "col-lg-4 text-break pre-line value-compare" }
const _hoisted_134 = {
  key: 3,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_135 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_136 = { class: "w-max-content col-lg-3 text-max-content" }
const _hoisted_137 = {
  key: 0,
  class: "col-lg-4 text-break"
}
const _hoisted_138 = {
  key: 1,
  class: "col-lg-4 text-break pre-line"
}
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_140 = { class: "col-lg-4 text-break pre-line value-compare" }
const _hoisted_141 = {
  key: 4,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_142 = { class: "mx-0 row px-0 pr-10" }
const _hoisted_143 = { class: "w-max-content col-lg-3 text-max-content" }
const _hoisted_144 = {
  key: 0,
  class: "col-lg-4 text-break"
}
const _hoisted_145 = {
  key: 1,
  class: "col-lg-4 text-break pre-line"
}
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-1 justify-content-center col-lg-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-right" })
], -1))
const _hoisted_147 = { class: "col-lg-4 text-break pre-line value-compare" }
const _hoisted_148 = { class: "col-12" }
const _hoisted_149 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_150 = { class: "ps-2 text-break pre-line mb-3" }
const _hoisted_151 = { class: "modal-footer d-flex justify-content-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { ALUMNI_REGISTER_FORM_STORE, COMMUNITY_ALUMNUS_STORE, REGISTER_STORE } from '@/store/constants'
import { computed } from 'vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import { checkAdditionalInformationChoiceOptionDisplayData, getAdditionalInformationChoiceOptionDisplayDataOE30 } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  formData: Object,
  status: String,
},
  emits: ['onCloseModal', 'onConfirm', 'onBackModalEdit'],
  setup(__props, { emit }) {

const props = __props

const store = useStore()
const title_data = computed(() => store.getters[ALUMNI_REGISTER_FORM_STORE.GETTERS.ENTRY_FORM])
const dataDetail = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_DETAIL_ALMNUS]?.detailAlmnus)
const communityRequiredData = computed(() => store.getters[REGISTER_STORE.GETTERS.COMMUNITY_REQUIRED_COLUMNS])


const onBackModalEdit = () => {
  emit('onBackModalEdit')
}
const confirmDataInfo = async () => {
  emit('onConfirm')
}
const checkDisplayEmpty = (value) => {
  if (value === '[]') return ''
  return value
}
const checkCompareValueByKey = (key) => {
  return (dataDetail.value?.obtained_information?.[key] ?? '') === (props.formData?.[key] ?? '')
}
const checkCompareTime = (key, format) => {
  return dayjs(dataDetail.value?.obtained_information?.[key]).format(format) === dayjs(props.formData?.[key]).format(format)
}
const checkCompareAdditions = (key) => {
  var origin_value = ''
  if (checkAdditionalInformationChoiceOptionDisplayData(dataDetail.value?.obtained_information?.[key])) {
    var array = getAdditionalInformationChoiceOptionDisplayDataOE30(dataDetail.value?.obtained_information?.[key])
    origin_value = array.join('\n')
  } else {
    origin_value = checkDisplayEmpty(dataDetail.value?.obtained_information?.[key]) ?? ''
  }
  return origin_value === props.formData?.[key]
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OE30confirmEditAddition')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (
                  _unref(communityRequiredData)?.corporation_organization_name !== 0 ||
                  _unref(communityRequiredData)?.corporation_department_name !== 0 ||
                  _unref(communityRequiredData)?.corporation_start_period !== 0 ||
                  _unref(communityRequiredData)?.corporation_end_period !== 0 ||
                  _unref(communityRequiredData)?.corporation_employee_id !== 0 ||
                  _unref(communityRequiredData)?.corporation_email !== 0 ||
                  _unref(communityRequiredData)?.corporation_family_name !== 0 ||
                  _unref(communityRequiredData)?.corporation_given_name !== 0
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(translate)('OE30warningMessageEditAddition')), 1),
                      _createElementVNode("h3", _hoisted_13, _toDisplayString(_unref(translate)('SA20information')), 1)
                    ]),
                    (_unref(communityRequiredData)?.corporation_organization_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(translate)('SA20corporationOrganizationName')), 1),
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(dataDetail)?.obtained_information?.corporation_organization_name), 1),
                            (!checkCompareValueByKey('corporation_organization_name'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_18,
                                  _createElementVNode("div", _hoisted_19, _toDisplayString(__props.formData?.corporation_organization_name), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(communityRequiredData)?.corporation_department_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(translate)('enrolledDepartmentName')), 1),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(dataDetail)?.obtained_information?.corporation_department_name), 1),
                            (!checkCompareValueByKey('corporation_department_name'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_24,
                                  _createElementVNode("div", _hoisted_25, _toDisplayString(__props.formData?.corporation_department_name), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(communityRequiredData)?.corporation_start_period !== 0 || _unref(communityRequiredData)?.corporation_end_period !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(translate)('enrollment')), 1),
                            (_unref(dataDetail)?.obtained_information?.corporation_start_period || _unref(dataDetail)?.obtained_information?.corporation_end_period)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  (_unref(dataDetail)?.obtained_information?.corporation_start_period)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(dayjs)(_unref(dataDetail)?.obtained_information?.corporation_start_period).format('YYYY/M')), 1))
                                    : _createCommentVNode("", true),
                                  _hoisted_31,
                                  (_unref(dataDetail)?.obtained_information?.corporation_end_period)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(dayjs)(_unref(dataDetail)?.obtained_information?.corporation_end_period).format('YYYY/M')), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_33)),
                            (!checkCompareTime('corporation_start_period', 'YYYY/M') || !checkCompareTime('corporation_end_period', 'YYYY/M'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _hoisted_34,
                                  (__props.formData?.corporation_start_period || __props.formData?.corporation_end_period)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                        (__props.formData?.corporation_start_period)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_unref(dayjs)(__props.formData?.corporation_start_period).format('YYYY/M')), 1))
                                          : _createCommentVNode("", true),
                                        _hoisted_37,
                                        (__props.formData?.corporation_end_period)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_unref(dayjs)(__props.formData?.corporation_end_period).format('YYYY/M')), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(communityRequiredData)?.corporation_employee_id !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(translate)('SA25employeeID')), 1),
                            _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(dataDetail)?.obtained_information?.corporation_employee_id), 1),
                            (!checkCompareValueByKey('corporation_employee_id'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_43,
                                  _createElementVNode("div", _hoisted_44, _toDisplayString(__props.formData?.corporation_employee_id), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(communityRequiredData)?.corporation_email !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("label", _hoisted_47, _toDisplayString(_unref(translate)('enrolledTimeEmailID')), 1),
                            _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(dataDetail)?.obtained_information?.corporation_email), 1),
                            (!checkCompareValueByKey('corporation_email'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_49,
                                  _createElementVNode("div", _hoisted_50, _toDisplayString(__props.formData?.corporation_email), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(communityRequiredData)?.corporation_family_name !== 0 || _unref(communityRequiredData)?.corporation_given_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("label", _hoisted_53, _toDisplayString(_unref(translate)('OE30nameAtTime')), 1),
                            _createElementVNode("div", _hoisted_54, _toDisplayString(!_unref(dataDetail)?.obtained_information?.corporation_family_name && !_unref(dataDetail)?.obtained_information?.corporation_given_name
                        ? ''
                        : _unref(dataDetail)?.obtained_information?.corporation_family_name + ' ' + _unref(dataDetail)?.obtained_information?.corporation_given_name), 1),
                            (!checkCompareValueByKey('corporation_family_name') || !checkCompareValueByKey('corporation_given_name'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_55,
                                  _createElementVNode("div", _hoisted_56, _toDisplayString(__props.formData?.corporation_family_name + ' ' + __props.formData?.corporation_given_name), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_57, [
              (
                  _unref(communityRequiredData)?.school_organization_name !== 0 ||
                  _unref(communityRequiredData)?.school_faclty_name !== 0 ||
                  _unref(communityRequiredData)?.school_department_name !== 0 ||
                  _unref(communityRequiredData)?.school_start_period !== 0 ||
                  _unref(communityRequiredData)?.school_end_period !== 0 ||
                  _unref(communityRequiredData)?.school_student_id !== 0 ||
                  _unref(communityRequiredData)?.school_email !== 0 ||
                  _unref(communityRequiredData)?.school_family_name !== 0 ||
                  _unref(communityRequiredData)?.school_given_name !== 0
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("h3", _hoisted_60, _toDisplayString(_unref(translate)('SA20informationAtSchool')), 1)
                    ]),
                    (_unref(communityRequiredData)?.school_organization_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("label", _hoisted_63, _toDisplayString(_unref(translate)('SA20schoolOrganizationName')), 1),
                            _createElementVNode("div", _hoisted_64, _toDisplayString(_unref(dataDetail)?.obtained_information?.school_organization_name), 1),
                            (!checkCompareValueByKey('school_organization_name'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_65,
                                  _createElementVNode("div", _hoisted_66, _toDisplayString(__props.formData?.school_organization_name), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(communityRequiredData)?.school_faclty_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("label", _hoisted_69, _toDisplayString(_unref(translate)('SA20facultyName')), 1),
                            _createElementVNode("div", _hoisted_70, _toDisplayString(_unref(dataDetail)?.obtained_information?.school_faclty_name), 1),
                            (!checkCompareValueByKey('school_faclty_name'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_71,
                                  _createElementVNode("div", _hoisted_72, _toDisplayString(__props.formData?.school_faclty_name), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(communityRequiredData)?.school_department_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("label", _hoisted_75, _toDisplayString(_unref(translate)('SA20departmentName')), 1),
                            _createElementVNode("div", _hoisted_76, _toDisplayString(_unref(dataDetail)?.obtained_information?.school_department_name), 1),
                            (!checkCompareValueByKey('school_department_name'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_77,
                                  _createElementVNode("div", _hoisted_78, _toDisplayString(__props.formData?.school_department_name), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(communityRequiredData)?.school_start_period !== 0 || _unref(communityRequiredData)?.school_end_period !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("label", _hoisted_81, _toDisplayString(_unref(translate)('SA20periodOfEnrollment')), 1),
                            (_unref(dataDetail)?.obtained_information?.school_start_period || _unref(dataDetail)?.obtained_information?.school_end_period)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                  (_unref(dataDetail)?.obtained_information?.school_start_period)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(_unref(dayjs)(_unref(dataDetail)?.obtained_information?.school_start_period).format('YYYY/M')), 1))
                                    : _createCommentVNode("", true),
                                  _hoisted_84,
                                  (_unref(dataDetail)?.obtained_information?.school_end_period)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(_unref(dayjs)(_unref(dataDetail)?.obtained_information?.school_end_period).format('YYYY/M')), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_86)),
                            (!checkCompareTime('school_start_period', 'YYYY/M') || !checkCompareTime('school_end_period', 'YYYY/M'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _hoisted_87,
                                  (__props.formData?.school_start_period || __props.formData?.school_end_period)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                        (__props.formData?.school_start_period)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(_unref(dayjs)(__props.formData?.school_start_period).format('YYYY/M')), 1))
                                          : _createCommentVNode("", true),
                                        _hoisted_90,
                                        (__props.formData?.school_end_period)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString(_unref(dayjs)(__props.formData?.school_end_period).format('YYYY/M')), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(communityRequiredData)?.school_student_id !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("label", _hoisted_94, _toDisplayString(_unref(translate)('SA20studentID')), 1),
                            _createElementVNode("div", _hoisted_95, _toDisplayString(_unref(dataDetail)?.obtained_information?.school_student_id), 1),
                            (!checkCompareValueByKey('school_student_id'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_96,
                                  _createElementVNode("div", _hoisted_97, _toDisplayString(__props.formData?.school_student_id), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(communityRequiredData)?.school_email !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("label", _hoisted_100, _toDisplayString(_unref(translate)('SA20emailAttendSchool')), 1),
                            _createElementVNode("div", _hoisted_101, _toDisplayString(_unref(dataDetail)?.obtained_information?.school_email), 1),
                            (!checkCompareValueByKey('school_email'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_102,
                                  _createElementVNode("div", _hoisted_103, _toDisplayString(__props.formData?.school_email), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(communityRequiredData)?.school_family_name !== 0 || _unref(communityRequiredData)?.school_given_name !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                          _createElementVNode("div", _hoisted_105, [
                            _createElementVNode("label", _hoisted_106, _toDisplayString(_unref(translate)('SA20nameAtSchool')), 1),
                            _createElementVNode("div", _hoisted_107, _toDisplayString(!_unref(dataDetail)?.obtained_information?.school_family_name && !_unref(dataDetail)?.obtained_information?.school_given_name
                        ? ''
                        : _unref(dataDetail)?.obtained_information?.school_family_name + ' ' + _unref(dataDetail)?.obtained_information?.school_given_name), 1),
                            (!checkCompareValueByKey('school_family_name') || !checkCompareValueByKey('school_given_name'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_108,
                                  _createElementVNode("div", _hoisted_109, _toDisplayString(__props.formData?.school_family_name + ' ' + __props.formData?.school_given_name), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (
                _unref(communityRequiredData)?.additional_information_1 ||
                _unref(communityRequiredData)?.additional_information_2 ||
                _unref(communityRequiredData)?.additional_information_3 ||
                _unref(communityRequiredData)?.additional_information_4 ||
                _unref(communityRequiredData)?.additional_information_5
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("h3", _hoisted_112, _toDisplayString(_unref(translate)('SA20additionalInformation')), 1)
                  ]),
                  (_unref(communityRequiredData)?.additional_information_1 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                        _createElementVNode("div", _hoisted_114, [
                          _createElementVNode("label", _hoisted_115, _toDisplayString(_unref(title_data)?.additional_information_1_question), 1),
                          (_unref(checkAdditionalInformationChoiceOptionDisplayData)(_unref(dataDetail)?.obtained_information?.additional_information_1))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(_unref(dataDetail)?.obtained_information?.additional_information_1), (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_117, _toDisplayString(checkDisplayEmpty(_unref(dataDetail)?.obtained_information?.additional_information_1)), 1)),
                          (!checkCompareAdditions('additional_information_1'))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _hoisted_118,
                                _createElementVNode("div", _hoisted_119, _toDisplayString(__props.formData?.additional_information_1), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(communityRequiredData)?.additional_information_2 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                        _createElementVNode("div", _hoisted_121, [
                          _createElementVNode("label", _hoisted_122, _toDisplayString(_unref(title_data)?.additional_information_2_question), 1),
                          (_unref(checkAdditionalInformationChoiceOptionDisplayData)(_unref(dataDetail)?.obtained_information?.additional_information_2))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(_unref(dataDetail)?.obtained_information?.additional_information_2), (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_124, _toDisplayString(checkDisplayEmpty(_unref(dataDetail)?.obtained_information?.additional_information_2)), 1)),
                          (!checkCompareAdditions('additional_information_2'))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _hoisted_125,
                                _createElementVNode("div", _hoisted_126, _toDisplayString(__props.formData?.additional_information_2), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(communityRequiredData)?.additional_information_3 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                        _createElementVNode("div", _hoisted_128, [
                          _createElementVNode("label", _hoisted_129, _toDisplayString(_unref(title_data)?.additional_information_3_question), 1),
                          (_unref(checkAdditionalInformationChoiceOptionDisplayData)(_unref(dataDetail)?.obtained_information?.additional_information_3))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(_unref(dataDetail)?.obtained_information?.additional_information_3), (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_131, _toDisplayString(checkDisplayEmpty(_unref(dataDetail)?.obtained_information?.additional_information_3)), 1)),
                          (!checkCompareAdditions('additional_information_3'))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _hoisted_132,
                                _createElementVNode("div", _hoisted_133, _toDisplayString(__props.formData?.additional_information_3), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(communityRequiredData)?.additional_information_4 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("label", _hoisted_136, _toDisplayString(_unref(title_data)?.additional_information_4_question), 1),
                          (_unref(checkAdditionalInformationChoiceOptionDisplayData)(_unref(dataDetail)?.obtained_information?.additional_information_4))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(_unref(dataDetail)?.obtained_information?.additional_information_4), (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(checkDisplayEmpty(_unref(dataDetail)?.obtained_information?.additional_information_4)), 1)),
                          (!checkCompareAdditions('additional_information_4'))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _hoisted_139,
                                _createElementVNode("div", _hoisted_140, _toDisplayString(__props.formData?.additional_information_4), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(communityRequiredData)?.additional_information_5 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                        _createElementVNode("div", _hoisted_142, [
                          _createElementVNode("label", _hoisted_143, _toDisplayString(_unref(title_data)?.additional_information_5_question), 1),
                          (_unref(checkAdditionalInformationChoiceOptionDisplayData)(_unref(dataDetail)?.obtained_information?.additional_information_5))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationChoiceOptionDisplayDataOE30)(_unref(dataDetail)?.obtained_information?.additional_information_5), (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_145, _toDisplayString(checkDisplayEmpty(_unref(dataDetail)?.obtained_information?.additional_information_5)), 1)),
                          (!checkCompareAdditions('additional_information_5'))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _hoisted_146,
                                _createElementVNode("div", _hoisted_147, _toDisplayString(__props.formData?.additional_information_5), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_148, [
              _createElementVNode("h3", _hoisted_149, _toDisplayString(_unref(translate)('OE30corporationHistoryNotes')), 1),
              _createElementVNode("div", _hoisted_150, _toDisplayString(__props.formData?.corporation_edit_history_notes), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_151, [
            _createVNode(Button, {
              title: _unref(translate)('titleButtonEdit'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold',
              onClick: onBackModalEdit
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: _unref(translate)('signUp'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold',
              onClick: confirmDataInfo
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})